<div
  class="transfer-indicator"
  [ngClass]="{ 'closed-sidebar': !isExpanded }"
  (click)="onToggleTooltip($event, tooltipTemplate)"
  tabindex="0"
  role="button"
  [attr.aria-label]="'View transfer status log'"
>
  <div
    class="icon-container"
    [ngClass]="{ 'justify-center': !isExpanded, 'blinking': hasActiveTransfers }"
  >
    <mat-icon>download</mat-icon>
  </div>

  <div *ngIf="isExpanded" class="transfer-stats">
    <div class="stats-row">
      <span class="stat-label">W:</span>{{ locatorStatus.remaining }}
      <span class="stat-divider">|</span>
      <span class="stat-label">V:</span>{{ locatorStatus.processed }}
    </div>
  </div>
</div>

<ng-template #tooltipTemplate>
  <div class="flex flex-col gap-3 bg-white rounded-lg p-4 min-w-[280px]">
    <!-- Header section -->
    <div class="flex flex-col gap-2">
      <div class="flex justify-between items-center border-b pb-2">
        <h3 class="font-medium text-gray-800 text-base">Status</h3>
        <mat-icon
          class="text-red-600 hover:text-red-800 cursor-pointer transition-colors duration-200"
          >delete</mat-icon
        >
      </div>

      <!-- Status information -->
      <div class="flex flex-col gap-2 bg-gray-50 p-3 rounded-md text-sm">
        <div class="flex justify-between items-center">
          <span class="text-gray-700">Warteschlange:</span>
          <span class="font-medium text-gray-900 bg-white px-2 py-0.5 rounded">{{
            locatorStatus.remaining
          }}</span>
        </div>

        <div class="flex justify-between items-center">
          <span class="text-gray-700">Verarbeitet:</span>
          <span class="font-medium text-gray-900 bg-white px-2 py-0.5 rounded">{{
            locatorStatus.processed
          }}</span>
        </div>
      </div>
    </div>

    <!-- Log section -->
    <div class="flex flex-col gap-2">
      <h4 class="font-medium text-gray-800 border-b pb-1">Log</h4>
      <div class="max-h-60 overflow-y-auto pr-1 rounded-md bg-gray-50">
        <div *ngFor="let log of locatorStatus.locatorLog" class="py-1">
          <div
            *ngIf="log.locator"
            [ngClass]="log.success ? 'text-green-600' : 'text-red-600'"
            class="px-2 py-1 text-sm font-light rounded hover:bg-gray-100"
          >
            {{ log.locator }}
          </div>
        </div>
        <div
          *ngIf="!locatorStatus.locatorLog?.length"
          class="px-2 py-2 text-sm text-gray-500 italic"
        >
          Keine Logeinträge vorhanden
        </div>
      </div>
    </div>
  </div>
</ng-template>
